import React, { useEffect, useState } from "react";
import { Modal, Select } from "antd";
import PropTypes from "prop-types";
// import { postRequest } from "../../axios"; // Assuming axios methods are set up properly
import "../../styles/Main.scss"; // Import your styles
import ConfirmDriverAssignment from "./ConfirmDriverAssignment";
// import { useTranslation } from "react-i18next";
import "antd/dist/antd.min.css";
import { authUserData } from "../../utils/Helper";
const { Option } = Select;

const DriverAssignment = ({
  record,
  driverList,
  setEmployeeList,
  setState,
  reload,
  setSelectedRow,
  setRouteIds,
  routeIds,
  setReload,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDriverId, setSelectedDriverId] = useState(
    record.assigned_to?.id || null
  );
  const [previousDriverId, setPreviousDriverId] = useState(
    record.assigned_to?.id || null
  );
  const [loading, setLoading] = useState(false);
  const [modalKey, setModalKey] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [reload, setReload] = useState(false);
  // const { t } = useTranslation();
   const hasPermission = authUserData()?.group[0]?.name;
  // const handleAddToExistingRoute = async () => {
  //   setLoading(true);
  //   try {
  //     const payload = {
  //       id: record.assigned_to_id,
  //       packages: [record.id],
  //       driver: selectedDriverId,
  //     };

  //     const response = await postRequest("add-to-existing-route/", payload);
  //     if (response.data.success) {
  //       updateDriverAssignment(
  //         record.id,
  //         selectedDriverId,
  //         response?.data?.data?.id
  //       );
  //     } else {
  //       console.error("Error adding to existing route", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("API call failed", error);
  //   } finally {
  //     setLoading(false);
  //     closeModal();
  //   }
  // };
  useEffect(() => {

    setSelectedDriverId(record?.assigned_to?.id);
  }, [record]);
  // const handleAssignOnlyDriver = async () => {
  //   setLoading(true);
  //   try {
  //     const payload = {
  //       id: record.assigned_to_id,
  //       packages: [record.id],
  //       driver: selectedDriverId,
  //     };

  //     const response = await postRequest("assign-package-to-driver/", payload);
  //     if (response.data.success) {
  //       updateDriverAssignment(
  //         record.id,
  //         selectedDriverId,
  //         response?.data?.data?.id
  //       );
  //     } else {
  //       console.error("Error assigning driver", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("API call failed", error);
  //   } finally {
  //     setLoading(false);
  //     closeModal();
  //   }
  // };

  // const handleUnassignDriver = async () => {
  //   setLoading(true);
  //   try {
  //     const payload = {
  //       id: record.assigned_to_id,
  //       packages: [record.id],
  //     };

  //     const response = await postRequest("unassign-driver/", payload);
  //     if (response.data.success) {
  //       updateDriverAssignment(record.id, null, null); // Unassign the driver
  //     } else {
  //       console.error("Error unassigning driver", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("API call failed", error);
  //   } finally {
  //     setLoading(false);
  //     closeModal();
  //   }
  // };

  // const updateDriverAssignment = (packageId, driverId, newAssignedToId) => {
  //     setEmployeeList((prevState) =>
  //         prevState.map((item) =>
  //             item.id === packageId
  //                 ? { ...item, assigned_to_id: newAssignedToId, assigned_to: { ...item.assigned_to, id: driverId } }
  //                 : item
  //         )
  //     );
  // };
  const updateDriverAssignment = (
    packageId,
    driverId,
    newAssignedToId,
    driverName
  ) => {
    console.log(
      packageId,
      driverId,
      newAssignedToId,
      driverName,
      "Package ID, Driver ID, New Assigned To ID, Driver Name"
    );

    setEmployeeList((prevState) =>
      prevState.map((item) =>
        item.id === packageId
          ? {
              ...item,
              assigned_to_id: newAssignedToId,
              assigned_to: { id: driverId, name: driverName }, // Ensure both id and name are updated
            }
          : item
      )
    );
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setSelectedDriverId(previousDriverId); // Revert back if canceled
  };

  const handleDriverChange = (value) => {
    setPreviousDriverId(selectedDriverId); // Store previous value
    setSelectedDriverId(value); // Update driver
    showModal(); // Show the confirmation modal
  };

  return (
    <>
      <Select
        className="gridselect" // Apply your CSS class
        onChange={handleDriverChange}
        showArrow
        placeholder="Select Driver"
        disabled={
          hasPermission === "Supervisor"
        }
        value={selectedDriverId}
      >
        {driverList?.map((driver) => (
          <Option key={driver.id} value={driver.id}>
            {driver.name}
          </Option>
        ))}
      </Select>

      {/* <Modal
                title="Confirm Driver Assignment"
                visible={isModalVisible}
                onCancel={closeModal}
                footer={[
                    <Button key="back" onClick={closeModal} className="ModalPopupFooter">
                        Cancel
                    </Button>,
                    <Button key="addRoute" onClick={handleAddToExistingRoute} loading={loading} type="primary" className="ModalPopupFooter">
                        Add to Existing Route
                    </Button>,
                    <Button key="assignDriver" onClick={handleAssignOnlyDriver} loading={loading} type="primary" className="ModalPopupFooter">
                        Assign Driver Only
                    </Button>,
                    <Button key="unassignDriver" onClick={handleUnassignDriver} loading={loading} type="danger" className="ModalPopupFooter">
                        Unassign Driver
                    </Button>,
                ]}
                width={600} // Adjust modal width
                style={{ top: 50 }} // Adjust the top margin to ensure visibility
            >
                <p>Select an action for this driver assignment:</p>
                <ul>
                    <li>Add to the existing route</li>
                    <li>Assign the driver only</li>
                    <li>Unassign the driver from the package</li>
                </ul>
            </Modal> */}

      <Modal
        title="Confirm Driver Assignment"
        open={isModalOpen}
        className="ModelPopupSecAssign"
        closable={false}
        wrapClassName="modal-wrapper"
        keyboard={false}
        visible={isModalVisible}
        onCancel={closeModal}
      >
        <ConfirmDriverAssignment
          fileList={fileList}
          setState={setState}
          setFileList={setFileList}
          driverList={driverList}
          setEmployeeList={setEmployeeList}
          record={record}
          reload={reload}
          setReload={setReload}
          closeModal={closeModal}
          setIsModalVisible={setIsModalVisible}
          updateDriverAssignment={updateDriverAssignment}
          setSelectedRow={setSelectedRow}
          setRouteIds={setRouteIds}
          routeIds={routeIds}
          // selectedDriverId={sele}
          //materialMasterId={materialMasterId}
          modalKey={modalKey}
          // setStateM={setState}
        />
      </Modal>
    </>
  );
};

DriverAssignment.propTypes = {
  record: PropTypes.object.isRequired,
  driverList: PropTypes.array.isRequired,
  setEmployeeList: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  setSelectedRow: PropTypes.array,
  setRouteIds: PropTypes.array,
  routeIds: PropTypes.array,
};

export default DriverAssignment;
